import React from 'react';
import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import i18n from '../../../../i18n';
import FeatureModels from '../../../../models/Feature';
var AMENITIES_BLOCK_LINE_COUNT = 2;
var nameMap = {
    ac: 'a-c',
    'kids-playground': 'playground',
    'high-speed-connection': 'high-speed-connexion',
    'dedicated-work-space': 'dedicated-workspace',
    'secured-swimming-pool': 'secured-pool'
};
export var AmenitiesGroup = function (_a) {
    var features = _a.features, _b = _a.amenities, amenities = _b === void 0 ? [] : _b, onUpdate = _a.onUpdate, title = _a.title;
    var featureMapping = function (name) {
        return nameMap[name] || name;
    };
    var getLabel = function (feature) {
        var labels = FeatureModels.AMENITIES_LABEL;
        return "home:feature-".concat(labels[feature.category], "-").concat(feature.icon);
    };
    return (React.createElement("div", null,
        React.createElement(CheckboxContainedGroup, { labelContent: title, collapsible: true, collapsed: true, showLines: AMENITIES_BLOCK_LINE_COUNT, showMore: i18n.t('home:show-more'), showLess: i18n.t('home:show-less') }, FeatureModels.filterAmenities()
            .filter(function (feature) { return features && features.includes(feature.category); })
            .map(function (feature) { return (React.createElement(CheckboxContained, { name: 'amenities', type: "checkbox", key: "amenities-".concat(feature.icon), label: i18n.t(getLabel(feature)), onChange: onUpdate, value: featureMapping(feature.icon), icon: feature.icon, checked: amenities.includes(featureMapping(feature.icon)), id: "gtm-track-".concat(featureMapping(feature.icon)) })); }))));
};
export default AmenitiesGroup;
